import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from '@shopify/polaris'
import humanizeTime from "../../../helpers/humanizeTime"
import { DownloadOutlined, CloseOutlined, ReloadOutlined, DeleteOutlined } from "@ant-design/icons";


const ExportTrackingTable = props => {
    const { index, item, handleClickCancel, handleClickRetry, handleClickDelete} = props

    const _mapTrackingStatus = status => {
        let lableStatus = '';
        switch(status) {
            case 'created':
                lableStatus = 'Created'
                break;

            case 'processing':
                lableStatus = 'Processing'
                break;

            case 'retry':
                lableStatus = 'Retry'
                break;

            case 'completed':
                lableStatus = 'Completed'
                break;

            case 'failed':
                lableStatus = 'Failed'
                break;

            case 'cancelled':
                lableStatus = 'Cancelled'
                break;

            default:
                lableStatus = '--'
        }

        return lableStatus
    }

    const handleDownload = () => {
        if(item.status === 'completed' && item.result_file && item.result_file.location){
            const link = document.createElement('a');
            link.href = item.result_file.location;
            link.download = item.file_name || 'file.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <React.Fragment>
            <tr key={index}>
                <td>
                    {item.file_name ? <a 
                        href={item.origin_file.location} target='_blank'
                        style={{ color: '#1890ff', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                        {item.file_name}
                    </a> : ''}
                </td>
                <td>{_mapTrackingStatus(item.status)}</td>
                <td>{item.createdAt ? humanizeTime(item.createdAt) : ''}</td>
                <td>{item.completed_at ? humanizeTime(item.completed_at) : ''}</td>
                <td>{item.processing_at ? humanizeTime(item.processing_at) : ''}</td>
                <td>
                    <div className="acions">
                        {
                            item.status === 'completed' &&
                            <Tooltip content="Download" preferredPosition="above">
                                <Button icon={<DownloadOutlined className="custom-button-download" style={{fontSize: '20px'}}/>} onClick={handleDownload} />
                            </Tooltip>
                        }
                        
                        {
                            (item.status === 'processing' || item.status === 'created' || item.status === 'retry') &&
                            <Tooltip content="Cancel" preferredPosition="above">
                                <Button icon={<CloseOutlined className="custom-button-cancel" style={{fontSize: '20px'}}/>} onClick={(e) => handleClickCancel(e, item._id)} />
                            </Tooltip>
                        }

                        {
                            (item.status === 'failed' || item.status === 'cancelled') &&
                            <Tooltip content="Retry" preferredPosition="above">
                                <Button icon={<ReloadOutlined className="custom-button-retry" style={{fontSize: '20px'}}/>} onClick={(e) => handleClickRetry(e, item._id)} />
                            </Tooltip>
                        }

                        {
                            item.status === 'cancelled' &&
                            <div style={{marginLeft: '5px'}}>
                                <Tooltip content="Delete" preferredPosition="above">
                                    <Button icon={<DeleteOutlined className="custom-button-delete" style={{fontSize: '20px'}}/>} onClick={(e) => handleClickDelete(e, item._id)} />
                                </Tooltip>
                            </div>
                        }
                    </div>
                </td>
            </tr>
        </React.Fragment>
    )
}

ExportTrackingTable.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    handleClickDelete: PropTypes.func.isRequired

}

export default ExportTrackingTable